module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": _vm.mergedOption.transition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showing),
      expression: "showing"
    }],
    staticClass: "et-wrapper",
    class: _vm.clazz,
    attrs: {
      "id": _vm.mergedOption.id,
      "transition": _vm.mergedOption.transition
    }
  }, [_c('span', {
    staticClass: "et-content",
    domProps: {
      "innerHTML": _vm._s(_vm.mergedOption.message)
    }
  }), _vm._v(" "), (_vm.mergedOption.closeable) ? _c('a', {
    staticClass: "et-close",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v("×")]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-22671b08"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/EasyToast.vue
// module id = 44
// module chunks = 0